import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import { Menu, MenuButton, MenuItem, MenuList, MenuTextButton } from 'components/Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SelectMenu(_ref) {
  var hasAssets = _ref.hasAssets,
    hasPlaylists = _ref.hasPlaylists,
    onSelect = _ref.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  return /*#__PURE__*/_jsxs(Menu, {
    id: menuId,
    children: [/*#__PURE__*/_jsx(MenuButton, {
      as: MenuTextButton,
      children: t('actions_select_all')
    }), /*#__PURE__*/_jsxs(MenuList, {
      children: [/*#__PURE__*/_jsx(MenuItem, {
        onClick: function onClick() {
          return onSelect('all');
        },
        children: t('actions_select_all')
      }), hasAssets && /*#__PURE__*/_jsx(MenuItem, {
        onClick: function onClick() {
          return onSelect('assets');
        },
        children: t('actions_select_all_assets')
      }), hasPlaylists && /*#__PURE__*/_jsx(MenuItem, {
        onClick: function onClick() {
          return onSelect('playlists');
        },
        children: t('actions_select_all_playlists')
      })]
    })]
  });
}
export default SelectMenu;